import { createnXtalAPI } from "src/api";
import { useCallback, useEffect, useState } from "react";
import { OptX } from "../models";

export const useFileXList = (optX: OptX) => {
  const [files, setFiles] = useState<Array<any>>([]);

  const nxtal = createnXtalAPI();

  const fetchFiles = useCallback(async () => {
    const res = await nxtal.optx.fetchFiles({
      contractorNo: sessionStorage.contractorNo,
      optXId: optX.optXId,
    });

    if (res.status === 200) setFiles(res.data);
  }, [nxtal.optx, optX.optXId]);

  // useEffect(() => {
  //   fetchFiles();
  // }, [fetchFiles]);

  useEffect(() => {
    fetchFiles();
  }, []);

  return { files };
};
